module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-wrapper"
  }, [(_vm.dataIsLoadedAndCalculated == true) ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "16px",
      "padding-bottom": "20px"
    }
  }, [_vm._v("Заявки")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "130px",
      "font-family": "'Roboto Light'",
      "font-size": "13px",
      "padding-bottom": "5px",
      "float": "left"
    }
  }, [_vm._v("\n      Активных заявок :\n    ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "calc(100%-130px)",
      "font-family": "'Roboto Light'",
      "font-size": "13px",
      "padding-bottom": "7px",
      "left": "clear"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.numActiveFinixTasks))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "130px",
      "font-family": "'Roboto Light'",
      "font-size": "13px",
      "padding-bottom": "5px",
      "float": "left"
    }
  }, [_vm._v("\n      Новых заявок :\n    ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "calc(100%-130px)",
      "font-family": "'Roboto Light'",
      "font-size": "13px",
      "padding-bottom": "7px",
      "left": "clear"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.numNewActiveFinixTasks))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "font-size": "13px",
      "padding-top": "20px"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/finixOrders"
    }
  }, [_vm._v("Открыть список заявок")])], 1)]) : _c('div', {
    staticClass: "one-news",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "16px",
      "padding-bottom": "20px"
    }
  }, [_vm._v("Заявки")]), _vm._v("\n    Загружаем данные...\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f654e0f","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FinixTasksWidget.vue
// module id = 405
// module chunks = 0